module.exports = __webpack_public_path__ + "img/linkedin.85c0fe70.jpg";